export default __webpack_public_path__ + "static/media/icon-twitter.5e850eb3.svg";